type PreviousLocation = { pathname: string; search?: string; hash?: string } | null;

type Options = {
  stateFrom: string | undefined;
  previousLocation: PreviousLocation;
  currentPathname: string;
  fallback: string;
};

export const resolveBackDestination = ({ stateFrom, previousLocation, currentPathname, fallback }: Options): string => {
  if (stateFrom) {
    return stateFrom;
  }
  if (previousLocation && previousLocation.pathname !== currentPathname) {
    return `${previousLocation.pathname}${previousLocation.search ?? ''}${previousLocation.hash ?? ''}`;
  }
  return fallback;
};
